import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios';
import { environment } from '../../../../env';
import LetterIntentModal from '../../../../components/Modal/LetterIntentModal'
import Table from '../../../../components/Table';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { warningModalToggle, loaderAction } from '../../../../redux/actions/Index';
import LetterViewModal from '../../../../components/Modal/LetterViewModal';
import SuccessPopups from '../../../../components/Popups/SuccessPopups';
import WarningPopup from '../../../../components/Popups/WarningPopup';
import ErrorPopups from '../../../../components/Popups/ErrorPopups';
import { Trash } from '@phosphor-icons/react';
import { Form, Label, Button } from 'reactstrap';
import moment from 'moment';
import ErrorComponents from '../../../../components/errorComponents/ErrorComponents';
import PathName from '../../../../components/PathName/PathName';

const Lot_intent = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.Reducers?.userdata);
  const [intentList, setIntentList] = useState([])
  const [update, setUpdate] = useState(false)
  const [open, setOpen] = useState(false)
  const [loisave, setLoisave] = useState(false)
  const deleteLotData = (id) => {
    dispatch(warningModalToggle(id));
  }
  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm();

  const deleteData = (id) => {
    dispatch(loaderAction())
    dispatch(warningModalToggle(id))
    axios.delete(`${environment.baseUrl}edit-intent-pdf/${id}`).then(res => {
      if (res.data.code === 200) {
        dispatch(loaderAction())
        GetIntentData();
      }
    })
      .catch(res => {
        dispatch(loaderAction())
        console.log("error");
        setOpen(true)
        setTimeout(() => {
          setOpen(false)
        }, [3000])
      })
  };

  const GetIntentDataa = () => {
    axios.get(`${environment.baseUrl}intent-pdf/`).then(res => {
      setIntentList(res.data)
    })
      .catch(res => {
        console.log("errorss");
      })
  }

  const columns = [
    {
      name: 'Company',
      selector: row => row.name_of_company,
            wrap: true,
            sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Contact',
      selector: row => row.contact_number,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Fax No',
      selector: row => row.fax_number,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Website',
      selector: row => row.website_url,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Select Investors',
      cell: (row) => <div className="d-flex justify-content-center w-50 align-items-center gap-2">
        <input type="checkbox" id="invarr" checked={row.on_use} className='checkinclusive' disabled></input>
      </div>,
    },
    {
      name: 'Action',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <LetterViewModal data={row} />
        {user?.role != 'user' && <>
          <LetterIntentModal update={setUpdate} updat={update} title='Edit Letter of Intent' button='edit' data={row} />
          {user?.role == 'superadmin' && <button onClick={() => delite(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="28" className='icon-color-red' /></button>}
        </>}
      </div>,
    },
  ];

  const GetIntentData = () => {
    try {
      axios.get(`${environment.baseUrl}addloi`).then((res) => {
        var indata = res.data[0]
        if (res.data[0]?.lessor_name == undefined) {
          setLoisave(true)
        }
        reset({
          "lessor_name": `${indata?.lessor_name}`,
          "lessor_address": `${indata?.lessor_address}`,
          "facility_location": `${indata?.facility_location}`,
          "rentalsqft": `Rs -(Rupees) per sq. ft. per month on the Built up area bifurcating as /- (All Inclusive) per month will be paid to the Lessor by the lessee from the date of possession of the scheduled property subject to physical measurement.`,
          "taxes": `${indata?.taxes}`,
          "refundable_security": `${indata?.refundable_security}`,
          "tenure": `${indata?.tenure}`,
          "lock_in_period": `${indata?.lock_in_period}`,
          "notice_period": `${indata?.notice_period}`,
          "stamp_duty": `${indata?.stamp_duty}`,
          "payment_terms": `${indata?.payment_terms}`,
          "licenses_approval": `${indata?.licenses_approval}`,
          "escalation_maintenance": `${indata?.escalation_maintenance}`,
          "parking_area": `${indata?.parking_area}`,
          "water_connection": `${indata?.water_connection}`,
          "electricity_charges": `${indata?.electricity_charges}`,
          "representation_lessor": `${indata?.representation}`,
          "additional_comments": `${indata?.additional_comments}`,
          "additional_comments1": `${indata?.additional_comments1}`,
          "additional_comments2": `${indata?.additional_comments2}`,
          "additional_comments3": `${indata?.additional_comments3}`,
        })
      })
    }
    catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
    }
  }

  useEffect(() => {
    reset({
      "rentalsqft": `Rs -(Rupees) per sq. ft. per month on the Built up area bifurcating as /- (All Inclusive) per month will be paid to the Lessor by the lessee from the date of possession of the scheduled property subject to physical measurement.`
    })
    GetIntentData()
    GetIntentDataa()
  }, [update])

  const lotFormSubmit = (data) => {
    data.possession_date = moment(new Date()).format('YYYY-MM-DD')
    try {
      if (loisave == true) {
        console.log("Hello")
      } else {
        axios.put(`${environment.baseUrl}editloi/${1}`, data).then((form) => {
          if (form.data.code === 200) {
            reset();
          } else {
            console.log("error")
          }
        })
      } return;
    }
    catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
    }
  }

  return (
    <>
      <PathName />
      <SuccessPopups />
      <ErrorPopups open={open} message={"Can't Delete"} />
      <WarningPopup deleteData={deleteData} />
      <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
        <div >
          <div className='d-flex justify-content-between align-items-center pb-5'>
            <h1 className='title-font-bold '>Letter Of Intent</h1>
            <LetterIntentModal update={setUpdate} button='create' />
          </div>
          <Table columns={columns} data={intentList} />
        </div>
      </div>
      <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
        <h1 className="fs-1 title-font-700 text-base-color py-3">Letter Of Intent</h1>

        <Form onSubmit={handleSubmit(lotFormSubmit)}>
          <div className="row">
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Name
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <input
                  className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  type="text"
                  placeholder="Enter Name..."
                  {...register("lessor_name", { required: true })}
                />
              </div>
              {errors.lessor_name && <ErrorComponents error={errors.name?.message} />}
              <br />
            </div>
            <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
              <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                Address of the Lessor
              </Label>
              <br />
              <div className='mt-1  d-flex gap-3'>
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder='Enter Address...'
                  {...register("lessor_address", { required: true })}
                ></textarea>
              </div>
              {errors.lessor_address && <ErrorComponents error={' POC Comments is required *'} />}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Location of the Facility
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder='Enter Address...'
                  {...register("facility_location", { required: true })}
                ></textarea>
              </div>
              {errors.facility_location && (
                <ErrorComponents error={errors.country?.message} />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Rental / Rs per sq. ft. per month (All Inclusive)
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder='Enter Rental / Rs per sq. ft. per month (All Inclusive)'
                  {...register("rentalsqft", { required: true })}
                ></textarea>
              </div>
              {errors.rentalsqft && (
                <ErrorComponents error={"Rental Price is required *"} />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Taxes
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder='Enter Taxes...'
                  {...register("taxes", { required: true })}
                ></textarea>
              </div>
              {errors.taxes && (
                <ErrorComponents error={"Taxes is required *"} />
              )}
              <br />
            </div>

            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Refundable Security Deposit
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder='Enter Refundable Security Deposit...'
                  {...register("refundable_security", { required: true })}
                ></textarea>
              </div>
              {errors.refundable_security && (
                <ErrorComponents
                  error={"Refundable Security Deposit  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Tenure
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <input
                  className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  type="text"
                  placeholder="Tenure"
                  {...register("tenure", { required: true })}
                />
              </div>
              {errors.tenure && (
                <ErrorComponents
                  error={"Tenure  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Lock In Period
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <input
                  className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  type="text"
                  placeholder="Lock In Period"
                  {...register("lock_in_period", { required: true })}
                />
              </div>
              {errors.lock_in_period && (
                <ErrorComponents
                  error={"Lock In Period  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Notice Period
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <input
                  className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  type="text"
                  placeholder="Notice Period"
                  {...register("notice_period", { required: true })}
                />
              </div>
              {errors.notice_period && (
                <ErrorComponents
                  error={"Notice Period  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Stamp Duty
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Stamp Duty"
                  {...register("stamp_duty", { required: true })}
                ></textarea>
              </div>
              {errors.stamp_duty && (
                <ErrorComponents
                  error={"Stamp Duty  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Payment Terms
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Refundable Security Deposit"
                  {...register("payment_terms", { required: true })}
                ></textarea>
              </div>
              {errors.payment_terms && (
                <ErrorComponents
                  error={"Payment Terms  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Licenses Approval
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Licenses Approval"
                  {...register("licenses_approval", { required: true })}
                ></textarea>
              </div>
              {errors.licenses_approval && (
                <ErrorComponents
                  error={"Licenses_Approval  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Escalation in Rent & Maintenance
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <input
                  className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  type="text"
                  placeholder="Escalation in Rent & Maintenance"
                  {...register("escalation_maintenance", { required: true })}
                />
              </div>
              {errors.escalation_maintenance && (
                <ErrorComponents
                  error={"Escalation in Rent & Maintenance  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Possession Date
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <input
                  className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  type="date"
                  placeholder="Possession Date"
                  {...register("possession_date")}
                />
              </div>
              {errors.possession_date && (
                <ErrorComponents
                  error={"Refundable Security Deposit  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Parking Area
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <input
                  className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                  type="number"
                  placeholder="Parking Area"
                  {...register("parking_area", { required: true })}
                />
              </div>
              {errors.parking_area && (
                <ErrorComponents
                  error={"Parking Area  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Electricity Charges
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Electricity Charges"
                  {...register("electricity_charges", { required: true })}
                ></textarea>
              </div>
              {errors.electricity_charges && (
                <ErrorComponents
                  error={"Electricity Charges  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Representation of the Lessor
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Representation of the Lessor"
                  {...register("representation_lessor", { required: true })}
                ></textarea>
              </div>
              {errors.representation_lessor && (
                <ErrorComponents
                  error={"Representation of the Lessor  is required *"}
                />
              )}
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Additional Comments
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Additional Comments"
                  {...register("additional_comments")}
                ></textarea>
              </div>
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Additional Comments 1
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Additional Comments"
                  {...register("additional_comments1")}
                ></textarea>
              </div>
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Additional Comments 2
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Additional Comments"
                  {...register("additional_comments2")}
                ></textarea>
              </div>
              <br />
            </div>
            <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
              <Label className="fs-4 title-font-500 mb-0 text-base-color">
                Additional Comments 3
              </Label>
              <br />
              <div className="mt-1  d-flex gap-3">
                <textarea
                  rows={4}

                  className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                  placeholder="Additional Comments"
                  {...register("additional_comments3")}
                ></textarea>
              </div>
              <br />
            </div>

          </div>
          <div className="d-flex justify-content-end align-items-center gap-4">
            <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' ><span className='fs-4 d-flex gap-3 title-font-600 px-3' >Cancel</span></Button>
            <Button type='submit' className='border-radius-7 p-3 d-flex align-items-center buttons' ><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Submit</span></Button>
          </div>
        </Form>

      </div>
    </>
  )
}

export default Lot_intent